import styles from './NumberIndicator.module.css';
import classNames from 'classnames';

const NumberIndicator = ({ number, visible }) => {
    return (
        <div className={classNames(styles.indicator, {[styles.hidden]: !visible })}>
            <span className={styles.indicator__number}>{number}</span>
        </div>
    );
}

export default NumberIndicator;
